import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function TrialCalendarForm({ location }) {
  console.log('TrialCalendarForm rendered: ', location)

  let init = {
    trialDateFrom: '',
    trialDateTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('TrialCalendarForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('TrialCalendarForm', navigate, inputs, 'trial.calendar')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Trial Calendar' />
            <tbody>
              <DateRangeInput label='Trial Date' name='trialDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.trialDateFrom} defaultValueTo={inputs.trialDateTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

